import { AuthService } from './../../service/auth.service';
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  active = 1;

  constructor(private auth: AuthService) {
  }

  ngOnInit() {
  }

  isAuth(): boolean {
    return this.auth.isAuthenticated();
  }

  onLogout() {
    this.auth.logout();
  }

}
